import { PHASE_ORDERING } from '../../../../constants';
import { computeRecommendations } from '../../../../helpers/computeRecommendations';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import EmptyState from 'components/EmptyState';

import RecommendationRow from 'pages/MaintenancePage/components/RecommendationRow';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, ModelServiceIntervalMap, Props } from './types';

const TabPanelParts: FunctionComponent<Props> = ({
    className = '',
    drone,
    droneNames,
    onAdd,
    phase,
    serviceIntervals,
    testId = TEST_ID
}) => {
    const { NO_PARTS_DRONE } = useTranslation();
    // serviceIntervals is already resolved to this drone's model upstream; key it
    // back under the drone's model so computeRecommendations resolves it identically.
    const recommendations = computeRecommendations({
        drones: [drone],
        serviceIntervals: { [drone.model]: serviceIntervals } as ModelServiceIntervalMap
    });
    const canAddToCart = phase >= PHASE_ORDERING;

    if (recommendations.length === 0) {
        return <EmptyState className={className} text={NO_PARTS_DRONE} />;
    }

    return (
        <VerticalContainer className={className} testId={testId}>
            {recommendations.map(recommendation => (
                <RecommendationRow
                    canAddToCart={canAddToCart}
                    droneNames={droneNames}
                    key={recommendation.partId}
                    onAdd={onAdd}
                    recommendation={recommendation}
                />
            ))}
        </VerticalContainer>
    );
};

export default TabPanelParts;
